/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Error_VerificationInputs */



/**
* | output |
* | --- |
* | "Verification failed." |
*
* @param {Auth_Error_VerificationInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_error_verification = /** @type {((inputs?: Auth_Error_VerificationInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Error_VerificationInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vérification échouée.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Verificación fallida.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Verificação falhou.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Verifica fallita.")
	return /** @type {LocalizedString} */ ("Verification failed.")
});